import script from "./CreateUpdateMetric.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateUpdateMetric.vue?vue&type=script&setup=true&lang=js"

import "./CreateUpdateMetric.vue?vue&type=style&index=0&id=c9007ec0&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ignis-pha-production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9007ec0"]])

export default __exports__